import { render, staticRenderFns } from "./exit-survey-response-details-board.vue?vue&type=template&id=178e0f3a&"
import script from "./exit-survey-response-details-board.vue?vue&type=script&lang=js&"
export * from "./exit-survey-response-details-board.vue?vue&type=script&lang=js&"
import style0 from "./exit-survey-response-details-board.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports